import React from 'react';
import ReactDOM from 'react-dom';

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this._updatePage = this._updatePage.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._nextPage = this._nextPage.bind(this);
  }

  _getQuery() {
    return JSON.parse(JSON.stringify(this.props.query));
  }
  _updatePage(page) {
    var model = this._getQuery();
    model.Page = page;
     this.props.onChange(model, true);
  }
  _previousPage(e){
    e.preventDefault();
    this._updatePage(this.props.query.Page - 1 );
  }  
  _nextPage(e){
    e.preventDefault();
    this._updatePage(this.props.query.Page + 1 );
  }
  render() {
    var hasPrevious = this.props.currentPage != 1;
    var hasNext = this.props.currentPage != this.props.totalPages;
    return (
      <nav className="text-center" aria-label="Page Navigation">
        <ul className="list-inline">
          <li className="list-inline-item float-sm-left">
            {hasPrevious && (
              <a onClick={this._previousPage} className="u-pagination-v1__item g-brd-around g-bg-gray-dark-v3 g-color-white g-bg-gray-dark-v2--hover g-rounded-50 g-pa-12-21 disabled" href="#" aria-label="Previous">
                <span aria-hidden="true">
                  <i className="fa fa-angle-left g-mr-5"></i>
                  Previous
                </span>
                <span className="sr-only">Previous</span>
              </a>
            )}
          </li>
          <li className="list-inline-item hidden-down">
            <a className="u-pagination-v1__item g-color-gray-dark-v3 g-pa-12-19">Page {this.props.currentPage} of {this.props.totalPages}</a>
          </li>
          <li className="list-inline-item float-sm-right">
            {hasNext && (
              <a onClick={this._nextPage} className="u-pagination-v1__item g-brd-around g-bg-gray-dark-v3 g-color-white g-bg-gray-dark-v2--hover g-rounded-50 g-pa-12-21" href="#" aria-label="Next">
                <span aria-hidden="true">
                  Next
                  <i className="fa fa-angle-right g-ml-5"></i>
                </span>
                <span className="sr-only">Next</span>
              </a>
            )}
          </li>
        </ul>
      </nav>
    );
  }
}
export default Pagination;